import { render, staticRenderFns } from "./NoContentOcorrencia.vue?vue&type=template&id=474cbd00&"
import script from "./NoContentOcorrencia.vue?vue&type=script&lang=js&"
export * from "./NoContentOcorrencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports